import { Fragment, useCallback, useEffect, useState } from "react";
import _, { set } from 'lodash';
import qs from 'querystring';
import dayjs from "dayjs";
import { MainLayout } from "./layout/MainLayout/MainLayout";
import { ManualLayout } from "./layout/ManualLayout/ManualLayout";
import { useDataStore } from "./store";
import { Parser } from "./utils/parser";
import { parseIndustryData } from "./modules/Overview/modules/utils";
import icon401 from './assets/401.png';

const params = qs.parse( window.location.search.replace(/^\?/,'') );

function App() {

	const [dataReady, setDataReady] = useState( false );
  //异常场景，需要给出提示
  const [ errorScene, setErrorScene ] = useState( null );
  const setUserInfo = useDataStore( state => state.setUserInfo); //存储用户信息
	const setContent = useDataStore(state => state.setContent);
	const setAccountant = useDataStore(state => state.setAccountant);
	const setCategoryMonthly = useDataStore(state => state.setCategoryMonthly);
	const setCommonTradings = useDataStore(state => state.setCommonTradings);
	const setPartyTrading = useDataStore(state => state.setPartyTrading);
	const setRiskItems = useDataStore(state => state.setRiskItems);
	const setInquiryTime = useDataStore( state => state.setInquiryTime );

	const processData = useCallback((data) => {

    if( !data || !data.content ) {
      return;
    }

		const parser = new Parser();
		parser.load( data?.content );
    setUserInfo( data?.userInfo );
		setContent( data?.content );
		setAccountant({
			avgMonthIncome: parser.avgMonthIncome,
			avgMonthExpense: parser.avgMonthExpense,
			totalIncome: parser.totalIncome,
			totalExpense: parser.totalExpense,
			incomeMonthly: parser.incomeMonthly,
			expenseMonthly: parser.expenseMonthly,
		});
		setCategoryMonthly(parser.categoryMonthly);
		setCommonTradings(parser.commonTradings);
		setPartyTrading(parser.partyTrading); // Assuming setPartyTrading is defined in the store
		setRiskItems({
			usuryPlatform: parser.usuryPlatform,
			leasePlatform: parser.leasePlatform,
			financialPlatform: parser.financialPlatform,
			largeAmountOrdersCount: parser.largeAmountOrdersCount,
			lastMonthRepayment: parser.lastMonthRepayment,
			familyConsumption: parser.familyConsumption,
			vehicleConsumption: parser.vehicleConsumption
		});
		setInquiryTime( parser.timeSpanEnd );
	}, [setContent, setAccountant, setCategoryMonthly, setCommonTradings, setPartyTrading, setRiskItems, setInquiryTime]);

	const handleManualData = useCallback((data) => {
    if( !params.token ) {
      //本地上传的文件，说明是体验版
      //记录每日调用次数
      let today = dayjs().format('YYYY-MM-DD');
      let lastInquiryDate = localStorage.getItem('lastInquiryDate');
      //如果不是今日，则重置调用次数
      if( lastInquiryDate !== today ) {
        localStorage.setItem('lastInquiryDate', today);
        localStorage.setItem('inquiryCount', '1');
      } else {
        let inquiryCount = localStorage.getItem('inquiryCount') || '0';
        inquiryCount = parseInt(inquiryCount) + 1;
        localStorage.setItem('inquiryCount', inquiryCount);
        if( inquiryCount > 5 ) {
          alert('今日体验次数已达上限，请明日再试。');
          return;
        }
      }
    }
    processData(data);
		setDataReady(true);

	}, [processData, setDataReady])

	useEffect(() => {
		if( params.token ) {
			getJson(params.token).then(handleManualData).catch(err => {
				setErrorScene(err);
			});
		}
	}, [params.token, handleManualData]);

	return <Fragment>
		{ !params.token && !dataReady && <ManualLayout callback={handleManualData} />}
		<MainLayout visible={dataReady} />
    { errorScene && <div className="error-scene">
        {errorScene !== 200 && <div className="item">
          <img src={icon401} width="300" height="300" /> 
          <p>链接已失效，请联系商家或平台管理员</p>
        </div>}
        <div className="copyright">Powered by 粒查查 - 驭川智能（杭州）科技有限公司</div>
    </div>}
	</Fragment>
}

function getJson ( token ) {

    let baseUrl = '';

    if( window.location.hostname === 'localhost' ) {
      baseUrl = 'https://safety-admin.sanxiangti.com';
    }
    else {
      baseUrl = window.location.protocol + '//' + window.location.hostname + ( window.location.port ? (':' + window.location.port) : '' );
    }

    return fetch( baseUrl + '/api/admin/shop/billAnalysis/queryByToken?token=' + token ).then(res => res.json()).then( data => {
        if( data.code !== 0 ) {
            return Promise.reject( data.code );
        }
        return data?.data;
    });
}

function generateLLMPrompt( userInfo, parser ) {
  let dataFrom = [];
  //统计所有信息，用于AI分析
  if( userInfo?.alipayID ) {
    dataFrom.push('支付宝账单');
  }
  if( userInfo?.wechatID ) {
    dataFrom.push('微信账单');
  }

  let llmPrompt = 
    '此报告来源于:' + dataFrom.join(',')
    + ';账单时间范围是:' + parser.timeSpanStart + '至' + parser.timeSpanEnd
    + ';用户信息如下,年龄:' + userInfo?.age
    + ',地区:' + userInfo?.addr
    + ',性别:' + (userInfo?.gender === 'F' ? '女' : '男')
    + ';平均月支出为:' + parser.avgMonthExpense
    + ',平均月收入为:' + parser.avgMonthIncome
    + ',在账单内的总支出为:' + parser.totalExpense
    + ',在账单内的总收入为:' + parser.totalIncome
    + ',在账单内的每月支出:' + JSON.stringify(parser.expenseMonthly)
    + ',在账单内的每月收入:' + JSON.stringify(parser.incomeMonthly)
    + '.';

    if( parser.financialPlatform.size > 0 ) {
      let FinancialData = parseIndustryData( parser.categoryMonthly, 'Financial' );
      llmPrompt += '涉及网络小贷、花呗等普惠金融产品:' + FinancialData.totalPartys + '家';
      llmPrompt += ',涉及资金共支出:' + FinancialData.totalExpense + '元';
      llmPrompt += ',涉及资金月平均支出:' + FinancialData.avgExpense + '元.';
    }
    if( parser.usuryPlatform.size > 0 || parser.leasePlatform.size > 0 ) {
      llmPrompt += '通过分析发现了以下风险项:';
      if( parser.usuryPlatform.size > 0 ) {
        let UsuryData = parseIndustryData( parser.categoryMonthly, 'Usury' );
        llmPrompt += '涉及高息借贷或民间借贷平台:' + UsuryData.totalPartys + '家'
        llmPrompt += ',涉及资金共支出:' + UsuryData.totalExpense + '元';
        llmPrompt += ',涉及资金月平均支出:' + UsuryData.avgExpense + '元.';
      }
      if( parser.leasePlatform.size > 0 ) {
        let LeaseData = parseIndustryData( parser.categoryMonthly, 'Lease' );
        llmPrompt += '涉及3C设备融资租赁平台:' + LeaseData.totalPartys + '家';
        llmPrompt += ',涉及租金共支出:' + LeaseData.totalExpense + '元';
        llmPrompt += ',涉及租金月平均支出:' + LeaseData.avgExpense + '元.';
      }
      llmPrompt += '近一个月共计还款' + parser.lastMonthRepayment.count + '笔, 共计还款' + parser.lastMonthRepayment.amount + '元.';
    }
    return llmPrompt;
}

export default App;
